import React from 'react';
import sanitizeHtml from 'sanitize-html';
import './MyRequests.scss';
import useMyRequestsVM from './useMyRequestsVM';
import { Loader } from 'components/Loader/Loader';
import { UserPageHeader } from 'components/UserPageHeader/UserPageHeader';
import { HistoryDetailLayout } from 'components/HistoryDetailLayout/HistoryDetailLayout';
import { NumberedHistoryCard } from 'components/NumberedHistoryCard/NumberedHistoryCard';
import { LoadMoreButton } from 'components/LoadMoreButton/LoadMoreButton';
import { EditableCommentField } from 'components/EditableCommentField/EditableCommentField';
import { ScrollToTopButton } from 'components/ScrollToTopButton/ScrollToTopButton';
import askIcon from 'assets/images/icons/users/menu/ask.svg';
import historyIcon from 'assets/images/icons/users/history.svg';
import detailIcon from 'assets/images/icons/users/request-details.svg';

export const MyRequests: React.FC = () => {
    const { me, requests, totalCount, hasMore, loadMore, selectedRequest, setSelectedRequest, formatDate, isLoading, handleSaveComment } = useMyRequestsVM();

    if (isLoading) return <main id="my-requests"><Loader /></main>;

    const firstname = me?.firstname ?? '';

    return (
        <main id="my-requests">
            <UserPageHeader icon={<img src={askIcon} alt="" />} title="Mes demandes" />

            <HistoryDetailLayout
                historyTitle="Mon historique de demande"
                historyIcon={<img src={historyIcon} alt="" />}
                detailTitle="Détail de la demande"
                detailIcon={<img src={detailIcon} alt="" />}
                history={
                    <>
                        {requests.length === 0 && <p>Aucune demande n'a encore été faite.</p>}
                        {requests.map((request: any, idx: number) => (
                            <NumberedHistoryCard
                                key={request.id}
                                number={totalCount - idx}
                                title={request.label}
                                subtitle={`Demande du ${formatDate(request.created_at)}`}
                                selected={selectedRequest?.id === request.id}
                                onClick={() => setSelectedRequest(request)}
                            />
                        ))}
                        {hasMore && (
                            <LoadMoreButton label="Voir les anciennes demandes" onClick={loadMore} />
                        )}
                    </>
                }
                detail={
                    selectedRequest ? (
                        <div className="my-requests__detail">
                            <h3>Commentaire FCV :</h3>
                            <div className="my-requests__comment" dangerouslySetInnerHTML={{ __html: sanitizeHtml((selectedRequest as any).observation ?? '') }} />
                            <EditableCommentField
                                label={`Commentaire écrit par ${firstname} :`}
                                value={(selectedRequest as any).user_comment}
                                onSave={handleSaveComment}
                            />
                        </div>
                    ) : <p>Sélectionnez une demande pour voir son détail.</p>
                }
            />

            <ScrollToTopButton />
        </main>
    );
};
